import React from 'react';
import { useDispatch } from 'react-redux';
import DropdownProperty from '../../../properties/DropdownProperty';
import NumberProperty from '../../../properties/NumberProperty';
import { StoreActions } from '../../../../state/store';
import BoolProperty from '../../../properties/BoolProperty';
import {IDropdownOption} from "../../../../interfaces/Misc";
import {useTypedDispatch, useTypedSelector} from "../../../../state/hooks";

export interface ParamClickableProps {
	file: string; // The file identifier for the operation
	index: number; // The index of the operation in the list
	param: {
		id: string | number; // The unique identifier for the parameter
		type?: 'dropdown' | 'number' | 'numberBig' | 'bool'; // Type of the parameter
		display?: string; // Display label for the parameter
		options?: IDropdownOption[]; // Options for dropdown (if applicable)
		min?: number; // Minimum value for number inputs
		max?: number; // Maximum value for number inputs
		step?: number; // Step value for number inputs
	};
	selectedOperation?: boolean; // Indicates if the operation is selected
	name?: string; // Name of the parameter
	onChangeCallback?: (value: string) => void; // Callback for parameter changes
}

export default function ParamClickable(props: ParamClickableProps)
{
	const dispatch = useTypedDispatch();

	const operation = useTypedSelector(state =>
	{
		return state.revisionModule.operations[props.file];
	});
	const value = operation[props.index].params[props.param?.id];

	if(!props.param) return null;

	function propertyChanged(val)
	{
		dispatch(StoreActions.revision.setItemParams({ file:props.file, operationIndex:props.index, property: props.param.id, value: val }));
	}
	
	const prepareRender = (() =>
	{
		if(!props.param.type)
		{
			return <label  style={{ color:'black', backgroundColor: props.selectedOperation ? 'yellow' : '', textDecoration:'underline', padding:"0px 5px 0px 5px", cursor:"pointer" }} onClick={
				(e) =>
				{
					if(props.onChangeCallback)
					{
						props.onChangeCallback('nodes')
					}
				}
			}>
				{props.name}
			</label>
		}

		if(props.param.type === 'dropdown')
		{
			return <DropdownProperty label={props.param.display ?? ""}
				options={props.param.options!}
				value={value}
				onChangeCallback={(v) =>
				{
					propertyChanged(v);
				}}/>
		}
		else if( props.param.type === 'number')
		{
			return <NumberProperty label={props.param.display ?? ""}
				min={props.param.min ?? undefined}
				max={props.param.max ?? undefined}
				step={props.param.step ?? 1}
				value={value}
				disableDrag
				onChangeCallback={(v) =>
				{
					propertyChanged(v);
				}}
				onCommitCallback={(v) =>
				{
					propertyChanged(v);
				}}/>
		}
		else if( props.param.type === 'numberBig')
		{
			return <NumberProperty label={props.param.display ?? ""}
				min={props.param.min ?? 1}
				max={props.param.max ?? undefined}
				step={props.param.step ?? 1}
				value={value}
				disableDrag
				splitbignumbers={","}
				onChangeCallback={(v) =>
				{
					propertyChanged(v);
				}}
				onCommitCallback={(v) =>
				{
					propertyChanged(v);
				}}/>
		}
		else if( props.param.type === 'bool')
		{
			return <BoolProperty label={props.param.display ?? ""}
				value={value}
				onChangeCallback={(v) =>
				{
					propertyChanged(v);
				}}/>
		}
	})();

	//render
	return (
		<>
			{prepareRender}
		</>
	)
}
